import {CommonFeatureGuard} from './common-feature-guard.service';
import {ActivatedRouteSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {inject} from '@angular/core';

export const SingleExportFeatureGuardCanActivate = (route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> => {
  return inject(CommonFeatureGuard).canActivate((features) => features.isSingleExportAvailable);
};
